import * as React from 'react';
import { withStyles } from "@material-ui/core";
import Icon from "storybookComponents/Icon"
import Expansion from "./expansion"

const styles = () => ({
  super: {
    width: "300px",
    background: "white",
    height: "100vh"
  },
  flexBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px 20px",
    fontSize: 16,
    lineHeight: "30px",
    color: "rgba(0, 0, 0, 1)",
    borderBottom: "1px solid #dadada"
  },
  closeIcon: {
    cursor: "pointer",
    height: "24px",
    "&:hover": {
      color: "#26bbed"
    }
  },
  bodyContainer: {
    padding: "12px 0px"
  },
});




export default withStyles(styles)(({ classes, title, onClose, date, propertiesName, campaignsName, activeStatusValues, leasedStatusValues, typeStatusValue, referredStatusValues }) => {
  return (
    <div className={classes.super}>
      <div className={classes.flexBox}>
        {title}
        <div className={classes.closeIcon}>
          <Icon onClick={onClose} type="icon-e-remove" size="lg" />
        </div>
      </div>
      <div className={classes.bodyContainer}>
        {
          propertiesName.length > 0 ? <Expansion title={`Properties (${propertiesName.length > 1 ? propertiesName.length : propertiesName[0]})`} list={propertiesName} tooltip={true} /> : null
        }
        {
          campaignsName.length > 0 ? <Expansion title={`Campaigns (${campaignsName.length > 1 ? campaignsName.length : campaignsName[0]})`} list={campaignsName} tooltip={true} /> : null
        }
        {
          activeStatusValues ?
            <Expansion title={`Status (${activeStatusValues.length == 2 ? "All" : activeStatusValues[0]})`} list={activeStatusValues} /> : null
        }
        {
          leasedStatusValues ?
            <Expansion title={`Leased (${leasedStatusValues.length == 2 ? "All" : leasedStatusValues[0]})`} list={leasedStatusValues} /> : null
        }
        {
          referredStatusValues ?
            <Expansion title={`Referred Status (${referredStatusValues.length == 2 ? "All" : referredStatusValues[0]})`} list={referredStatusValues} /> : null
        }
        {
          typeStatusValue ?
            <Expansion title={`Type (${typeStatusValue[0]})`} list={typeStatusValue} /> : null
        }
        <Expansion title={`Date (${date[0]})`} list={date} />
        {/* <Expansion title={`Status (${status[0]})`} list={status} /> */}
      </div>
    </div>
  );
})